

















































import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {Notification, Level} from '@/model/Notification';

import {NotificationStore} from '@/store/Notification.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import {Watch} from 'vue-property-decorator';
import {EventBus} from '@/utils/EventBus';

@Component({
  components: {},
})
export default class Notifications extends Mixins<BaseComponent>(BaseComponent) {
  private notificationStore: NotificationStore = getModule(NotificationStore, this.$store);

  private iconsMap: Map<Level, string> = new Map([
    [Level.Success, 'mdi-check-circle'],
    [Level.Info, 'mdi-information'],
    [Level.Warn, 'mdi-alert'],
    [Level.Error, 'mdi-close-octagon'],
  ]);

  private timeoutMap: Map<Level, number> = new Map([
    [Level.Success, 3000],
    [Level.Info, 5000],
    [Level.Warn, 5000],
    [Level.Error, 10000],
  ]);

  private colorMap: Map<Level, string> = new Map([
    [Level.Success, 'success'],
    [Level.Info, 'info'],
    [Level.Warn, 'warning'],
    [Level.Error, 'error'],
  ]);

  private timeoutId: any = null;

  get notifications(): Notification[] {
    return this.notificationStore.DisplayedNotifications;
  }

  private ackItem(id: string) {
    this.notificationStore.ackNotification(id);
    this.removeItem(id);
  }

  private removeItem(id: string) {

    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    this.notificationStore.dismissNotification(id);

    if (this.notifications.length > 0) {
      return this.processItems();
    }
  }

  @Watch('notifications')
  private processItems() {
    if (this.notifications.length > 0) {
      const item = this.notifications[0];
      const timeout = this.timeoutMap.get(item.Level);
      if (timeout && timeout > 0) {
        return this.timeoutId = setTimeout(() => {
          this.removeItem(item.Id);
        }, timeout);
      }
    }
  }

  private openNotificationCenter() {
    EventBus.Emit(EventBus.Event.OpenNotificationCenter);
  }
}
